import React, {Component} from "react";
import initStyle from "../styles/about.style";
import icon_b from "../assets/about/icon_b.svg";
import icon_c from "../assets/about/icon_c.svg";
import about from "../json/about.json";
import { Translate, withLocalize } from 'react-localize-redux'
import { withSiteData, NavLink, Link, withRouteData, Head } from 'react-static'
import { LazyImage } from 'react-lazy-images'

import plogo1 from '../assets/prix/a.png'
import plogo2 from '../assets/prix/b.png'
import plogo3 from '../assets/prix/c.png'
import plogo4 from '../assets/prix/d.png'
import plogo5 from '../assets/prix/e.png'

import innovation from '../assets/2022/photos/a-propos/innovation.jpeg';
import investiv from '../assets/2022/photos/a-propos/investiv.jpg';
import ourne from '../assets/2022/photos/a-propos/ourne.webp';
import professional from '../assets/2022/photos/a-propos/professional.webp';
import respectMutuel from '../assets/2022/photos/a-propos/respect-mutuel.JPG';
import founder from '../assets/2022/photos/a-propos/aboubakar.webp';
import midHeaderImage from '../assets/investiv-about.jpg';

import pour from '../assets/2022/photos/a-propos/pour.webp';
import check from '../assets/2022/photos/a-propos/check.webp';
import mapple from '../assets/2022/photos/a-propos/mapple.webp';

import oneSDG from "../assets/2022/photos/a-propos/sdgs/one-no-poverty.png";
import twoSDG from "../assets/2022/photos/a-propos/sdgs/two-zero-hunger.webp";
import threeSDG from "../assets/2022/photos/a-propos/sdgs/three-health-wealth.webp";
import fourSDG from "../assets/2022/photos/a-propos/sdgs/eight-economic-growth.webp";
import fiveSDG from "../assets/2022/photos/a-propos/sdgs/eleven-sus-city-goals.webp";
import sixSDG from "../assets/2022/photos/a-propos/sdgs/twelve-response.webp";
import sevenSDG from "../assets/2022/photos/a-propos/sdgs/fifteen-life-land.webp";
import nineSDG from "../assets/2022/photos/a-propos/sdgs/nine-industry-innovation.png";
import captions from "../translations/captions.json";

import ContactPanel from "../shared-components/contact-panel";

const teamReq = require.context('../assets/team/', false);
const getTeamPic = link => link.startsWith('http') ? link : teamReq('./' + `${link}`);
const teamPics = Object.keys(about).reduce(
  (acc, newEl) => ({...acc, [newEl]: about[newEl].map((e) => getTeamPic(e.link))}), {});

const FirstIteration  = () => {

  const AboutStyle = initStyle("first");

  return (
    <AboutStyle option= "first" className="xs-12">
      <Head>
        <title>Investiv Group | A propos</title>
      </Head>

      <div className="xs-12 withBackground">
        <div className="c-w relative">
          <div className="c t-c">
            <h3> <Translate id="about.title" options={{ onMissingTranslation: () => "About Us" }} /> </h3>
          </div>
        </div>
      </div>

      <div className="xs-10 xs-off-1">
        <div className="xs-10 xs-off-1 sm-10 sm-off-1" id="about-lift">
          <div className="cards">
            <div className="xs-12 md-6 card f-l">
              <div className="xs-12  inner">
                <div className="c-w">
                  <div className="c">
                    <div className="xs-3">
                      <img src={icon_b} />
                    </div>
                    <div className="xs-9">
                      <h4> Vision </h4>
                      <p>
                      <Translate id="about.visionText" options={{ onMissingTranslation: () => "Building the future of African agriculture by focusing on precision agriculture." }} />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="xs-12 md-6 card f-r">
              <div className="xs-12  inner">
                <div className="c-w">
                  <div className="c">
                    <div className="xs-3">
                      <img src={icon_c} />
                    </div>
                    <div className="xs-9">
                      <h4>  <Translate id="about.objective" options={{ onMissingTranslation: () => "Objective" }} /> </h4>
                      <p>
                      <Translate id="about.objectiveText" options={{ onMissingTranslation: () => "Become a leader in agricultural advisory services in Africa with precision farming experience" }} />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="xs-10 xs-off-1 sm-8 sm-off-2 content">
          <p>
           <Translate id="about.p_one" options={{ onMissingTranslation: () => "Investiv is an Ivorian company specialized in the service of precision agriculture. A pioneer in the use of drones in agriculture in West Africa, we provide our customers with technical and innovative solutions that combine productivity, performance and time savings. These solutions allow them to reduce the losses related to phytosanitary problems at first glance, then to know with precision the state and the dimensions of their lands, finally, to follow the evolution of their agricultural activities and to make preliminary technical studies. to the implementation of their agricultural project. We work with many categories of clients, including: individuals wanting to enter agriculture, professionals in the agricultural sector, producers themselves, agricultural cooperatives, institutions that fund agricultural projects, government institutions, agricultural businesses and NGOs that support the agricultural sector." }} />
          </p>
        </div>
      </div>

      <div className="xs-10 xs-off-1 top">
        <div className="xs-12" id="Equipe">

          <div className="xs-12 pre t-c">
            <h2>
              <Translate id="about.team" options = {{  onMissingTranslation: () => "Team"  }} />
            </h2>
            <h4>
              <Translate id="about.team_one"  options = {{  onMissingTranslation: () => "Agronomic Team" }} />
            </h4>
          </div>

          <div className="xs-12 top">
            {about.equip.map((p, i) => {
              return (
                <div className="xs-12 sm-6 md-4 info-card" key={i}>
                  <div className="inner">
                    <img src={teamPics.equip[i]} />
                    <h4>{p.name}</h4>
                    <p>{p.title}</p>
                  </div>
                </div>
              );
            })}
          </div>

        </div>

        <div className="xs-12 top" id="Equipe">
          <div className="xs-12 pre t-c">

            <h4>
              <Translate id="about.team_two" options = {{  onMissingTranslation: () => "Technological Team" }} />
            </h4>
          </div>

          <div className="xs-12 top">
            {about.technologies.map((p, i) => {
              return (
                <div className="xs-12 sm-6 md-4 info-card" key={i}>
                  <div className="inner">
                    <img src={teamPics.technologies[i]} />
                    <h4>{p.name}</h4>
                    <p>{p.title}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="xs-12 top" id="Equipe">
          <div className="xs-12 pre t-c">
            <h4> <Translate id="about.team_three" options = {{  onMissingTranslation: () => "Administrative Team" }} /> </h4>
          </div>

          <div className="xs-12 top">
            {about.admins.map((p, i) => {
              return (
                <div className="xs-12 sm-6 md-4 info-card" key={i}>
                  <div className="inner">
                    <img src={teamPics.admins[i]} />
                    <h4>{p.name}</h4>
                    <p>{p.title}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="xs-12 top" id="Equipe">
          <div className="xs-12 pre t-c">
            <h4> <Translate id="about.team_four" options = {{ onMissingTranslation: () => "Drone Pilots" }} /> </h4>
          </div>

          <div className="xs-12 top">
            {about.drone.map((p, i) => {
              return (
                <div className="xs-12 sm-6 md-4 info-card" key={i}>
                  <div className="inner">
                    <img src={teamPics.drone[i]} />
                    <h4>{p.name}</h4>
                    <p>{p.title}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </AboutStyle>
  );
};

class SecondIteration extends Component {

  constructor(props){
    super(props);
    this.state = {
      overlayOpen: false
    }
  }

  openModal = (e, dataName) => {
    e.preventDefault();
    this.setState({ dataName, overlayOpen: true });
  }

  closeModal = () => {
    this.setState({
      overlayOpen: false
    })
  }

  render(){

    const AboutStyle = initStyle("second");

    const id = (dataName)=>{
      switch (dataName) {
        case "respectMutuel":
          return "captions.respectMutuel";
        case "ourne":
          return "captions.ourne";
        case "professional":
          return "captions.professional";
        default:
          return "captions.innovation";
      }
    }
    return (
    <AboutStyle option= "second" className = "xs-12">

      <Head>
        <title>Investiv Group | A propos</title>
      </Head>

      {
        this.state.overlayOpen && (
          <section className="xs-12" id="overlay-modal" onClick={this.closeModal}>
            <button onClick={this.closeModal}>Close</button>
            <p className="xs-10 xs-off-1 sm-8 sm-off-2" style = {{ color: "white", margin: "0 2em" }}>
              <Translate id={id(this.state.dataName)}/>
            </p>
          </section>
        )
      }

      <section className ="xs-12 body">

        <div className="xs-12 header">
          <div className="xs-12 md-11" style={{ margin: "auto" }}>
            <h3><Translate id="aboutV2.header.one" options = {{ onMissingTranslation: () => "About" }} /></h3>
            <p><Translate id="aboutV2.header.two" options = {{ onMissingTranslation: () => "Supporting our farmers through innovation"}} /></p>
          </div>
        </div>

        <div className="xs-12 md-11 text-after-header">
          <div className="xs-12 md-6">
            <h3><Translate id="aboutV2.text.right" options = {{ onMissingTranslation: () => "Aerial drone technology meets agricultural productivity"}}/></h3>
          </div>
          <div className="xs-12 md-6">
            <p> <Translate id="aboutV2.text.left.one" options = {{ onMissingTranslation: () => "Investiv is an agri-tech company specializing in precision agriculture and drone technology. Founded in 2017, the company remains steadfast in its commitment to establish itself as the pioneer for drone technology in Africa."}}/></p>
            <br/>
            <p> <Translate id="aboutV2.text.left.two" options = {{ onMissingTranslation: () => "It offers its partners and customers technical and innovative solutions that combine productivity, performance and time savings." }}/></p>
            <br/>
            <p> <Translate id="aboutV2.text.left.three" options = {{ onMissingTranslation: () => "These solutions allow them to reduce losses linked to phytosanitary problems, to know precisely the state and dimensions of their land, to follow the evolution of their agricultural activities and to carry out technical studies prior to the implementation of their agricultural project."}}/></p>
            <br/>
          </div>
        </div>

        <div className="xs-12">
          <h1 className="t-c av">
           <Translate id='about.values'/>
         </h1>
        </div>

        <div className="xs-12 md-11 images-after-header">

          <div className="xs-12 md-6">
            <NavLink to ="" onClick={e => this.openModal(e,"innovation")} >
              <img src={innovation} alt="" />
              <h3> <Translate id="home.approache.list.one"/> </h3>
            </NavLink>
            <NavLink to ="" onClick={e => this.openModal(e,"respectMutuel")}>
              <img src={respectMutuel} alt="" />
              <h3><Translate id="home.approache.list.two"/></h3>
            </NavLink>
          </div>

          <div className="xs-12 md-6">
            <NavLink to ="" onClick={e => this.openModal(e,"ourne")}>
              <img src={ourne} alt="" />
              <h3><Translate id="home.approache.list.three"/></h3>
            </NavLink>
            <NavLink to ="" onClick={e => this.openModal(e,"professional")}>
              <img src={professional} alt="" />
              <h3> <Translate id="home.approache.list.four"/></h3>
            </NavLink>
          </div>

        </div>

        <div className="xs-12 founder-bar">
          <div className='xs-12 md-11' style={{ margin: "auto" }}>
          <h2><Translate id="aboutV2.header.five"/></h2>
          <h4><Translate id="aboutV2.header.six"/></h4>
          <p><Translate id="aboutV2.text.left.five"/></p>

          <div className="xs-12 founder-image">
            <img src={founder} alt="founder" />
            <p>Aboubacar Karim - <Translate id="aboutV2.founder"/></p>
          </div>
          </div>

        </div>

        <div className="xs-12 md-11 solutions">
          <div className="xs-12 md-6">
            <h2><Translate id="aboutV2.header.seven"/></h2>
          </div>
          <div className="xs-12 md-6">
            <p><Translate id="aboutV2.text.left.four.one"/></p>
            <br/>
            <p><Translate id="aboutV2.text.left.four.two"/></p>
            <br/>
            <p><Translate id="aboutV2.text.left.four.three"/></p>
            <br/>
            <p><Translate id="aboutV2.text.left.four.four"/></p>
            <br/>

          </div>
        </div>

        <section className="mid-header">
          <img src = {midHeaderImage} alt="midHeaderImage"/>
          <h3><Translate id="aboutV2.midheader.heading"/> </h3>
          <p><Translate id="aboutV2.midheader.text"/> </p>
        </section>

        <section className="xs-12 md-11" id="just-more-logos">
          <div className="xs-12">

            <div className="xs-12 md-6">
              <h4><Translate id="home.headings.distinctions" /></h4>
            </div>

            <div className="xs-12 md-6">
              <p id="distinctions-paragraph">
                <Translate id="home.distinctionsText" />
              </p>
            </div>

            <div className="xs-12" style={{ margin: "2em auto 2em"}}>
              <div className="in">
              <div className="xs-6 sm-4 md-2 flex">
                <LazyImage
                  placeholder={({ imageProps, ref }) => (
                    <div className="imgPlaceholder" ref={ref} />)}
                  actual={({ imageProps }) => (<img {...imageProps} />)}
                  src={plogo1} className="xs-12 md-11" />
                <p className="image-caption"><Translate id="home.awardOne" /></p>
              </div>
              <div className="xs-6 sm-4 md-2 flex">
                <LazyImage
                  placeholder={({ imageProps, ref }) => (
                    <div className="imgPlaceholder" ref={ref} />)}
                  actual={({ imageProps }) => (<img {...imageProps} />)}
                  src={plogo2} className="xs-12 md-11" />
                <p className="image-caption"><Translate id="home.awardTwo" /></p>
              </div>
              <div className="xs-6 sm-4 md-2 flex">
                <LazyImage
                  placeholder={({ imageProps, ref }) => (
                    <div className="imgPlaceholder" ref={ref} />)}
                  actual={({ imageProps }) => (<img {...imageProps} />)}
                  src={plogo3} className="xs-12 md-11" />
                <p className="image-caption">
                  <Translate id="home.awardThree" />
                </p>
              </div>
              <div className="xs-6 sm-4 md-2 flex">
                <LazyImage
                  placeholder={({ imageProps, ref }) => (
                    <div className="imgPlaceholder" ref={ref} />)}
                  actual={({ imageProps }) => (<img {...imageProps} />)}
                  src={plogo4} className="xs-12 md-11" />
                <p className="image-caption"><Translate id="home.awardFour" /></p>
              </div>
              <div className="xs-12 sm-4 md-3 flex">
                <LazyImage
                  placeholder={({ imageProps, ref }) => (
                    <div className="imgPlaceholder" ref={ref} />)}
                  actual={({ imageProps }) => (<img {...imageProps} />)}
                  src={plogo5} className="xs-12 md-11" />
                <p className="image-caption">
                  <Translate id="home.awardFive" />
                </p>
              </div>
              </div>

            </div>

          </div>
        </section>

        <div className ="xs-12 impact">

        <div className="inner xs-12">
          <div className = "xs-12 md-6">
            <h3><Translate id = "aboutV2.impact.heading" /></h3>
          </div>

          <div className = "xs-12 md-6">
            <p id="other-paragraph"><Translate id = "aboutV2.impact.text" /> </p>
          </div>
        </div>

        <div className="xs-12 md-4 box">
          <img src={pour} alt=""/>
          <p>
            <Translate id = "aboutV2.impact.boxes.one.plain" />
            <span><Translate id = "aboutV2.impact.boxes.one.bold" /></span>
          </p>
        </div>

        <div className="xs-12 md-4 box">
          <img src={check} alt=""/>
          <p>
            <Translate id = "aboutV2.impact.boxes.two.plain" />
            <span><Translate id = "aboutV2.impact.boxes.two.bold" /></span>
          </p>
        </div>

        <div className="xs-12 md-4 box">
          <img src={mapple} alt=""/>
          <p>
            <Translate id = "aboutV2.impact.boxes.three.plain" />
            <span><Translate id = "aboutV2.impact.boxes.three.bold" /></span>
          </p>
        </div>

        <div className="xs-12 sdgs">

          <div className = "xs-12 t-c">
            <br/>
            <h1><Translate id = "sdgs.heading" /></h1>
            <br/><br/>
          </div>

          <div className="xs-12  md-6 md-off-3">
            <div className="xs-12 sm-6 lg-3 t-c">
              <img src = {twoSDG} alt="twoSDG"/>
            </div>

            <div className="xs-12 sm-6 lg-3 t-c">
              <img src = {fourSDG} alt="fourSDG"/>
            </div>

            <div className="xs-12 sm-6 lg-3 t-c">
              <img src = {sixSDG} alt="sixSDG"/>
            </div>

            <div className="xs-12 sm-6 lg-3 t-c">
              <img src = {nineSDG} alt="nineSDG"/>
            </div>
          </div>

        </div>

        </div>

      </section>

      <ContactPanel/>

    </AboutStyle>
  );
  }
}

export default withLocalize(SecondIteration);



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/About.js